import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Armé mi primera banqueta Japandi en un fin de semana con madera del corralón de la vuelta. La vendí antes de terminarla. Nunca pensé que iba a poder hacer esto.',
  author: 'Martín S.',
  location: 'Rosario',
  role: 'Fabricante Japandi sin experiencia previa'
}, {
  quote: 'Las medidas, los planos y el paso a paso están tan bien explicados que no tuve que buscar nada más. Terminé mi mesa ratona en 10 horas y la vendí a $85.000.',
  author: 'Florencia G.',
  location: 'CABA',
  role: 'Emprendedora, vendió su primer mueble en 3 días'
}, {
  quote: 'Calculé mi fórmula de precio, publiqué en Instagram con las fotos que explica el Tomo 5 y tuve 4 consultas en el primer día. Esto es un negocio real.',
  author: 'Diego M.',
  location: 'Córdoba',
  role: 'Fabricante Japandi con lista de espera de clientes'
}];
export function Testimonials() {
  return <section className="py-8 md:py-16 px-4 bg-white" data-id="element-271">
      <div className="max-w-4xl mx-auto" data-id="element-272">
        <div className="flex flex-col gap-3 md:gap-4" data-id="element-273">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileTap={{
          scale: 0.99
        }} className="flex items-start gap-3 md:gap-4 bg-[#F5F0E8] p-3 md:p-5 rounded-lg border border-[#2B2724]/10" data-id="element-274">
              <div className="flex-shrink-0 flex items-center justify-center w-9 h-9 md:w-11 md:h-11 rounded-full bg-[#C2613A]/10" data-id="element-275">
                <Quote className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-276" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-277">
                <div className="flex gap-0.5 mb-1.5" data-id="element-278">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-3.5 md:h-3.5 fill-[#C2613A] text-[#C2613A]" data-id="element-279" />)}
                </div>
                <p className="text-xs md:text-sm italic leading-relaxed mb-1.5" data-id="element-280">
                  "{testimonial.quote}"
                </p>
                <p className="text-[11px] md:text-xs" data-id="element-281">
                  <span className="font-semibold" data-id="element-282">
                    {testimonial.author} {testimonial.location}
                  </span>
                  <span className="text-[#2B2724]/60" data-id="element-283">
                    {' '}
                    — {testimonial.role}
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}